import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class CSVFileService {
	private URL = environment.api;

	constructor(private http: HttpClient) { }

	uploadFile(file) {
		const formData = new FormData();
		formData.append('file', file.uploadFile);
		return this.http.post(this.URL + file.endPoint, formData);
	}
}